<template>
  <template v-for="choice in choices" :key="choice.value">
    <div
      v-if="(!filtered || (choice.checked && filtered)) && (!choice.archived || (choice.archived && archivedFilter))"
      class="checkbox-primary custom-control custom-checkbox"
    >
      <input
        :id="'checkbox-' + itemModel.vars.name + '-' + choice.value"
        v-model="choice.checked"
        :class="
          (itemModel.vars.error ? 'custom-control-input is-invalid' : 'custom-control-input') +
          (itemModel.vars.attr && itemModel.vars.attr.class ? ' ' + itemModel.vars.attr.class : '')
        "
        :disabled="itemModel.vars.disabled || choice.disabled"
        :readonly="(itemModel.vars.attr && itemModel.vars.attr.readonly) || readonly"
        :value="choice.value"
        type="checkbox"
        @change="setChecked"
        @focus="focus"
      />
      <label
        :for="'checkbox-' + itemModel.vars.name + '-' + choice.value"
        :class="'custom-control-label ps-2' + (choice.badges ? ' badged' : '')"
      >
        <span :class="choice.class ? ' ' + choice.class : ''">{{ truncateLabel(choice.label) }}</span>
        <span
          v-if="labelNeedTruncation(choice.label)"
          class="text-muted"
          v-tooltip="{ title: choice.label, textWrap: true }"
          >...</span
        >
        <span v-if="choice.badges && choice.badges.length" class="d-flex flex-wrap justify-content-end">
          <span
            v-for="(badge, index) in choice.badges"
            :key="index"
            :class="'badge mb-1 bg-' + (badge?.type ? badge.type : 'success')"
            >{{ badge.label.toLowerCase() }}</span
          >
        </span>
        <template v-if="choice.attr && choice.attr['data-icon'] && Object.keys(choice.attr['data-icon']).length">
          <span
            v-for="(icon, index) in choice.attr['data-icon']"
            :key="index"
            v-tooltip="{ title: icon.tooltip ? icon.tooltip : '' }"
            :class="'ms-2 ' + (icon.class ? icon.class : '')"
          >
            <FontAwesomeIcon v-if="icon.icon" :icon="'fa-light fa-' + icon.icon" />
          </span>
        </template>
      </label>
    </div>
  </template>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "CheckboxInputComponent",
  components: { FontAwesomeIcon },
  props: {
    model: {
      type: Object,
      required: true,
    },
    choices: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    filtered: {
      type: Boolean,
      required: false,
      default: false,
    },
    archivedFilter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["setChecked", "focus"],
  data() {
    return {
      itemModel: this.model,
      labelMaxLength: 130,
    };
  },
  mounted() {
    this.setLabelMaxLength();
  },
  computed: {
    needToBeTruncate() {
      return !!this.model.vars && this.model.vars.attr && this.model.vars.attr["truncate-choice-label"];
    },
  },
  methods: {
    setChecked() {
      this.$emit("setChecked");
    },

    setLabelMaxLength() {
      if (window.innerWidth < 768) {
        this.labelMaxLength = 40;
      } else if (window.innerWidth < 992) {
        this.labelMaxLength = 50;
      } else if (window.innerWidth < 1200) {
        this.labelMaxLength = 90;
      } else {
        this.labelMaxLength = 130;
      }
    },

    truncateLabel(label) {
      if (this.labelNeedTruncation(label) && this.needToBeTruncate) {
        return label.substring(0, this.labelMaxLength);
      }
      return label;
    },

    labelNeedTruncation(label) {
      return !!(label && this.needToBeTruncate && label.length > this.labelMaxLength);
    },

    focus() {
      this.$emit("focus");
    },

    iconToDisplay(id) {
      return this.model.vars.attr["data-icons"].filter((element) => element.id === id);
    },

    getColor(icon) {
      const textDanger = ["link-slash"];
      let color;
      if (textDanger.includes(icon)) {
        color = "text-danger";
      }
      return color;
    },
  },
};
</script>

<style scoped lang="scss">
.badged {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.badge + .badge {
  margin-left: 5px;
}

.is-invalid + label {
  &:before {
    border-color: $red;
  }
}

.custom-control-label {
  min-height: 20px;
}
</style>
